// Generated by GitHub Copilot
import React from "react";
import { Card } from "react-bootstrap";
import styles from "./SummaryMetricCard.module.css";

const SummaryMetricCard = ({
  title,
  value,
  subtitle,
  icon,
  variant = "light",
  size = "md",
  onClick,
  isSelected = false,
  isClickable = false,
}) => {
  // Generated by GitHub Copilot
  // Handle card click - only trigger if clickable and onClick provided
  const handleClick = () => {
    if (isClickable && onClick) {
      onClick(title);
    }
  };

  // Generated by GitHub Copilot
  // Build dynamic class names based on state
  const cardClasses = [
    styles.summaryCard,
    styles[variant],
    styles[size],
    isClickable ? styles.clickable : "",
    isSelected ? styles.selected : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Card
      className={cardClasses}
      onClick={handleClick}
      style={{ cursor: isClickable ? "pointer" : "default" }}
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
      aria-pressed={isClickable ? isSelected : undefined}
      aria-label={
        isClickable
          ? `Filter by ${title} status. ${value} ${title.toLowerCase()} impacts. ${
              isSelected ? "Currently selected." : "Click to apply filter."
            }`
          : `${value} ${title.toLowerCase()} impacts`
      }
      onKeyDown={
        isClickable
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleClick();
              }
            }
          : undefined
      }
    >
      <Card.Body className={styles.cardBody}>
        <div className={styles.value}>{value}</div>
        <div className={styles.title}>{title}</div>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      </Card.Body>
    </Card>
  );
};

export default SummaryMetricCard;
